import { Button, Col, Row } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import TitleWithBackNavigation from '../../../../components/TitleWithBackNavigation'
import CustomDayPicker from './customDayPicker'
import { ApiCaller, Colors } from '../../../../config'
import { yupResolver } from '@hookform/resolvers/yup'
import { businessInfoSchema } from './schema'
import { useDispatch, useSelector } from 'react-redux'
import { setError, setMessage } from '../../../../store/common/generalSlice'
import { useNavigate } from 'react-router-dom'
import { useMutation } from 'react-query'
import { fetchProfileData } from '../../../../store/common/settingSlice'
import { days } from '../../../../config/utils/constants'

const AddSchedule = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const workingDaysRef = useRef(null);

    const { profileData } = useSelector(state => state?.setting);

    // a state to hold the timePickers array after onChange as directly using onChange of a form
    // clearing the entire array of working days.
    const [timePickers, setTimePickers] = useState([]);

    // need only in case of edit
    const [isDisabled, setIsDisabled] = useState(true);


    // custom error handling 
    const [customError, setCustomError] = useState({
        time: '',
        services: ''
    })

    const [updatedDayRecord, setUpdatedDayRecord] = useState(null);

    const { control, handleSubmit, reset, formState: { isDirty } } = useForm({
        mode: 'onChange'
    })

    // pre filled the form data in case of edit
    useEffect(() => {
        if (profileData && profileData?.workingDays?.length > 0) {
            reset({
                workingDays: profileData?.workingDays ? profileData?.workingDays : []
            })
            if (profileData?.workingDays) {
                const workingDays = profileData?.workingDays?.map((timePicker) => {
                    return {
                        ...timePicker,
                        dayChecked: true
                    }
                })
                setTimePickers(workingDays)
                workingDaysRef.current = workingDays;
            }
        }
    }, [profileData])

    useEffect(() => {
        if (updatedDayRecord && Object.keys(updatedDayRecord)?.length > 0) {
            const originalTimePicker = workingDaysRef?.current;
            let isDisable = true;
            const originalTimePickerObject = originalTimePicker?.find(item => item?.day === updatedDayRecord?.day);
            // in case where no working days record found initially.
            if (originalTimePicker == null) {
                isDisable = false;
            }
            // if data exists already of that day.
            else if (originalTimePickerObject !== undefined) {
                if (originalTimePickerObject?.day !== updatedDayRecord?.day ||
                    originalTimePickerObject?.startTime !== updatedDayRecord?.startTime ||
                    originalTimePickerObject?.endTime !== updatedDayRecord?.endTime ||
                    originalTimePickerObject?.closed !== updatedDayRecord?.closed ||
                    originalTimePickerObject?.fullDay !== updatedDayRecord?.fullDay ||
                    originalTimePickerObject?.dayChecked !== updatedDayRecord?.dayChecked
                ) {
                    isDisable = false;
                }
            }
            // if user changes in any of the day.
            else if (updatedDayRecord) {
                isDisable = false;
            }
            setIsDisabled(isDisable)
        }
    }, [timePickers, updatedDayRecord])

    const businessInfoMutation = useMutation(async (data) => {
        let res = await ApiCaller.put('/user/update-business-workingdays', data);
        return res
    },
        {
            onSuccess: (res) => {
                dispatch(setMessage(res?.data?.data?.message))
                // reset({
                //     workingDays: []
                // })
                // setCustomFieldReset({ ...customFieldReset, time: true })
                setCustomError({ time: '' })
                dispatch(fetchProfileData())
                setUpdatedDayRecord(null)
                setIsDisabled(true)
                // setTimePickers([])
                // navigate('/settings')
            },

            onError: (error) => {
                dispatch(setError(error?.response?.data?.error?.message))
            }
        }
    )

    // const submitForm = (data) => {

    //     let cloneTimePicker = [...timePickers];

    //     let validCases;
    //     console.log(cloneTimePicker)
    //     if (cloneTimePicker?.length == 0) {
    //         setCustomError({ ...customError, time: 'Time is required' });
    //         return
    //     }

    //     if (cloneTimePicker) {
    //         // Check if there is at least one valid object with the required conditions
    //         const hasValidCondition = cloneTimePicker.some((subItem) => {
    //             return subItem?.dayChecked && (
    //                 subItem?.startTime !== null ||
    //                 // subItem?.time !== null ||
    //                 subItem?.closed === true ||
    //                 subItem?.fullDay === true
    //             );
    //         });

    //         console.log(hasValidCondition)

    //         // Check if there is an object where dayChecked is true but time is null and closed is false (invalid case)
    //         const hasInvalidDayChecked = cloneTimePicker.some((subItem) => {
    //             return subItem?.dayChecked && subItem?.startTime === null && !subItem?.closed && !subItem?.fullDay;
    //         });

    //         // Check if there is an object where dayChecked is false but time exists (invalid case)
    //         const hasTimeButNoDayChecked = cloneTimePicker.some((subItem) => {
    //             return !subItem?.dayChecked && subItem?.startTime !== null;
    //         });

    //         // If any invalid case is found or if no valid condition exists, show the error
    //         if (!hasValidCondition || hasInvalidDayChecked || hasTimeButNoDayChecked) {
    //             setCustomError({ ...customError, time: 'Time and day check is required' });
    //             return;
    //         }

    //         // If all checks pass, filter and return valid cases
    //         validCases = cloneTimePicker.filter((subItem) => {
    //             return subItem?.dayChecked && (
    //                 subItem?.startTime !== null ||
    //                 // subItem?.time !== null ||
    //                 subItem?.closed === true || 
    //                 subItem?.fullDay === true
    //             );
    //         });

    //         setCustomError({ ...customError, time: '' });
    //     }

    //     console.log(validCases)
    //     // Log or handle updatedWorkingDays
    //     let workingDays = validCases
    //         .map(item => {
    //             let startTime, endTime;
    //             // Check if time is an array
    //             if (Array.isArray(item?.time)) {
    //                 startTime = (item?.closed || item?.fullDay) ? null : (item?.time[0] || null);
    //                 endTime = (item?.closed || item?.fullDay) ? null : (item?.time[1] || null);
    //             } else {
    //                 // If not an array, use separate startTime and endTime keys
    //                 startTime = (item?.closed || item?.fullDay) ? null : item?.startTime;
    //                 endTime = (item?.closed || item?.fullDay) ? null : item?.endTime;
    //             }
    //             return {
    //                 day: item?.day,
    //                 startTime,
    //                 endTime,
    //                 closed: item?.closed,
    //                 fullDay: item?.fullDay
    //             };
    //         })
    //         .filter(item => !(item?.startTime === null && item?.endTime === null && (!item?.closed && !item?.fullDay))); // Remove items with null times unless closed is true

    //     console.log(workingDays)
    //     // Log or handle updatedWorkingDays
    //     let updatedWorkingDays = workingDays
    //         .filter(item => !(item?.startTime == null && item?.endTime == null && (!item?.closed && !item.fullDay))) // Remove items with null times unless closed is true
    //         .map(item => {
    //             if (item?.closed && item?.day) {
    //                 // If the item is closed, return an object with only 'day' and 'closed' and 'fullDay'
    //                 return {
    //                     day: item?.day,
    //                     closed: item?.closed,
    //                     fullDay: item?.fullDay
    //                 };
    //             }
    //             else if (item?.fullDay && item?.day) {
    //                 // If the item is fullDay, return an object with only 'day' and 'closed' and 'fullDay'
    //                 return {
    //                     day: item?.day,
    //                     closed: item?.closed,
    //                     fullDay: item?.fullDay
    //                 };
    //             }
    //             return item; // Otherwise, return the item as is
    //         });

    //     console.log(updatedWorkingDays)

    //     let payload = {
    //         workingDays: updatedWorkingDays,
    //     }

    //     businessInfoMutation.mutate(payload)

    // }

    const submitForm = (data) => {
        const cloneTimePicker = [...timePickers];

        if (cloneTimePicker?.length === 0) {
            setCustomError({ ...customError, time: 'Time is required' });
            return;
        }

        let isValid = true;

        for (const item of cloneTimePicker) {
            const { dayChecked, startTime, endTime, closed, fullDay } = item;

            const hasTime = startTime !== null && endTime !== null;
            const hasClosure = closed === true || fullDay === true;

            if (dayChecked) {
                // day is checked, but neither time nor closed/fullDay selected
                if (!hasTime && !hasClosure) {
                    isValid = false;
                    break;
                }
            } else {
                // day not checked, but has time or closed/fullDay
                if (hasTime || closed || fullDay) {
                    isValid = false;
                    break;
                }
            }
        }

        if (!isValid) {
            setCustomError({ ...customError, time: 'Each selected day must have time, closed, or fullDay. Unselected days must not have any value.' });
            return;
        }

        setCustomError({ ...customError, time: '' });

        // Proceed to filter and prepare payload
        const workingDays = cloneTimePicker
            .filter(item => item.dayChecked)
            .map(item => {
                const { day, startTime, endTime, closed, fullDay } = item;

                if (closed || fullDay) {
                    return { day, closed, fullDay };
                }

                return { day, startTime, endTime, closed: false, fullDay: false };
            });

        const payload = {
            workingDays,
        };

        console.log("Final Payload:", payload);
        businessInfoMutation.mutate(payload);
    };

    return (
        <>
            <TitleWithBackNavigation title={'Working Days'} link={'/settings/businessInfo'} />
            <Row justify={'space-between'} className='my-4'>
                <Col lg={10} md={12} sm={24} xs={24} className='mb-4'>
                    <form>
                        <Controller
                            name='workingDays'
                            control={control}
                            defaultValue={[]}
                            render={({ field: { value, onChange }, fieldState }) => {
                                return (
                                    <Col md={24} sm={24} xs={24}>
                                        <CustomDayPicker
                                            value={value || timePickers}
                                            onChange={(data) => {
                                                const cloneTimePicker = [];
                                                data?.forEach((dayRecord) => {
                                                    delete dayRecord?.time;
                                                    cloneTimePicker.push(dayRecord)
                                                })
                                                setTimePickers(cloneTimePicker);
                                                // setIsDisabled(false)
                                                // if (profileData?.workingDays?.length > 0 && !isDisabled.isWorkingDaysDirty) {
                                                //     setIsDisabled({ ...isDisabled, isWorkingDaysDirty: true })
                                                // }
                                                // onChange(data)
                                            }}
                                            updatedRecord={(updatedItem) => setUpdatedDayRecord(updatedItem)}
                                        // customFieldReset={customFieldReset.time}
                                        // setCustomFieldReset={setCustomFieldReset}
                                        />
                                        {customError?.time && <p className='text-red-500'>{customError?.time}</p>}
                                    </Col>
                                )
                            }}
                        />
                        <Button
                            onClick={handleSubmit((data) => submitForm(data))}
                            loading={businessInfoMutation.isLoading}
                            htmlType='submit'
                            disabled={isDisabled}
                            className='w-36 h-10 mt-3 rounded-md outline-none border-none'
                            style={{ background: Colors.AppYellow, color: 'white' }}>
                            Save
                        </Button>
                    </form>
                </Col>
            </Row >
        </>
    )
}

export default AddSchedule